import { useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { getNameList } from 'country-list';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import api from "../helpers/crmApis";
import { useLocation, useNavigate } from "react-router-dom";
import { decodeData } from "./Constant/Constant";
import { Toast } from 'primereact/toast';

const industryOptions = [
  { value: 'Technology', label: 'Technology' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Retail', label: 'Retail' },
  { value: 'Manufacturing', label: 'Manufacturing' },
  { value: 'Education', label: 'Education' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Media & Entertainment', label: 'Media & Entertainment' },
  { value: 'Travel & Tourism', label: 'Travel & Tourism' },
  { value: 'Food & Beverage', label: 'Food & Beverage' },
  { value: 'Automotive', label: 'Automotive' },
  { value: 'Other', label: 'Other' }
]

const companySizeOptions = [
  { value: '1-10', label: '1-10 employess' },
  { value: '11-50', label: '11-50 employess' },
  { value: '51-200', label: '51-200 employess' },
  { value: '201-500', label: '201-500 employess' },
  { value: '501-1000', label: '501-1000 employess' },
  { value: '1000+', label: '1000+ employess' }
]

export default function MultiStepForm() {
  const toast = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [countryOptions, setCountryOptions] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [tenentData, setTenentData] = useState(null);
  const [formData, setFormData] = useState({
    companyName: "",
    website: "",
    industry: "",
    country: "",
    size: "",
    role: "",
    objectives: [],
    otherObjText: "",
    otherObjectives: []
  });

  const [formErrors, setFormErrors] = useState({
    companyName: {showError: false, message: ""},
    industry: {showError: false, message: ""},
    country: {showError: false, message: ""},
    size: {showError: false, message: ""},
    role: {showError: false, message: ""},
  });

  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value });
    setFormErrors({ ...formErrors, [key]: { showError: false, message: "" } });
  };

  const handleObjective = (key, event) => {
    let currentFormData = { ...formData };
    if (event?.checked) {
      if (!currentFormData?.objectives?.includes(event?.value)) {
        currentFormData = {
          ...currentFormData,
          objectives: [...currentFormData?.objectives, event?.value]
        }
      } 
    } else {
      if (event?.value == 'other') {
        currentFormData = {
          ...currentFormData,
          otherObjectives: [],
          otherObjText: ""
        }
      }
      currentFormData = {
        ...currentFormData,
        objectives: currentFormData?.objectives?.filter((item) => item !== event?.value)
      }
    }
    setFormData(currentFormData);
    setFormErrors({ ...formErrors, [key]: { showError: false, message: "" } });
  }

  const handleOtherObjective = (event) => {
    if (event?.key === "Enter") {
      event.preventDefault();
      let currentFormData = { ...formData };
      if (!currentFormData?.otherObjectives?.includes(event?.target?.value)) {
        currentFormData = {
          ...currentFormData,
          otherObjectives: [...currentFormData?.otherObjectives, event?.target?.value],
          otherObjText: ""
        }
      } 
      setFormData(currentFormData);
    }
  }

  const getAllObjectives = () => {
    let mainObjectives = formData?.objectives?.filter((item) => item !== 'other');
    return [...mainObjectives, ...formData?.otherObjectives];
  }

  const validateCompanyInfo = () => {
    let valid = true;
    let errors = { ...formErrors };
    if (formData.companyName == "") {
      errors = { ...errors, companyName: { showError: true, message: "Company name is required" } }
      valid = false;
    }
    if (formData.industry == "") {
      errors = { ...errors, industry: { showError: true, message: "Industry is required" } }
      valid = false;
    }
    if (formData.country == "") {
      errors = { ...errors, country: { showError: true, message: "Country is required" } }
      valid = false;
    }
    if (formData.size == "") {
      errors = { ...errors, size: { showError: true, message: "Size is required" } }
      valid = false;
    }
    setFormErrors(errors);
    return valid;
  }

  const validateRoleInfo = () => {
    let valid = true;
    if (!formData.role) {
      setFormErrors((prev) => {
        return {
          ...prev,
          role: { showError: true, message: "Role is required" }
        }
      })
      valid = false;
    }
    return valid;
  }

  const nextStep = () => {
    let isValid = true;
    if (step == 1) {
      isValid = validateCompanyInfo();
      if (isValid) setStep((prev) => Math.min(prev + 1, 3))
    } else if (step == 2) {
      isValid = validateRoleInfo();
      if (isValid) setStep((prev) => Math.min(prev + 1, 3))
    }
  }
  const prevStep = () => setStep((prev) => Math.max(prev - 1, 1));

  const handleSubmit = async () => {
    try {
      let formPayload = {
        tenantName: formData.companyName,
        tenantSize: formData.size,
        website: formData.website,
        industry: formData.industry,
        country: formData.country,
        tenantRole: formData.role,
        goals: getAllObjectives()?.join(', ')
      }
      setIsFormSubmitted(true);
      let res = await api.post(`/auth/create-tenant?email=${formData?.email}`, formPayload);
      setTenentData(res?.data);
      if (res) {
        setStep(-1);
        setIsFormSubmitted(false);
        setFormData({
          companyName: "",
          website: "",
          industry: "",
          country: "",
          size: "",
          role: "",
          objectives: [],
          otherObjText: "",
          otherObjectives: []
        })
      }
    } catch (error) {
      setIsFormSubmitted(false);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error?.response?.data?.error });
    }
  };

  const handleResetForm = () => {
    window.open(`${tenentData?.url}/admin/login?query=${encodeURIComponent(JSON.stringify({ accessToken: tenentData?.accessToken, tenantId: tenentData?.tenantId }))}`, '_self');
    // setStep(1);
    // setFormData({
    //   companyName: "",
    //   website: "",
    //   industry: "",
    //   country: "",
    //   size: "",
    //   role: "",
    //   objectives: [],
    //   otherObjText: "",
    //   otherObjectives: []
    // })
    // setIsFormSubmitted(false);
  }

  const getCompletePercentage = (step) => {
   let percent = (step / 3) * 100
   return step == -1 ? '100%' : `${percent.toFixed(0)}%`;
  };

  const getCapetalize = (str) => {
    return str
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  useEffect(() => {
    // const queryParams = new URLSearchParams(location.search);
    // let queryData = queryParams.get("query");
    // queryData = queryData ? JSON.parse(decodeURIComponent(queryData)) : null;
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('query');

    const queryData = token ? decodeData(token) : null;
    if (queryData?.isValid) {
      setFormData((prev) => ({
        ...prev,
        email: queryData?.email || "",
        password: queryData?.password || "",
      }))
    } else {
      navigate('/signup');
    }
  }, [location])

  useEffect(() => {
    let countryList = getNameList();
    countryList = Object.keys(countryList).map((key) => ({ label: getCapetalize(key), value: countryList[key] }));
    setCountryOptions(countryList);
  }, [])

  return (
    <div className="max-w-[45%] mx-auto p-6 bg-white h-screen flex flex-col justify-center">
      <Toast ref={toast} />
      {/* Progress bar */}
      <div className="flex flex-col items-center justify-center mb-6">
        <h2 className="text-[26px] font-semibold">Welcome to Our Platform</h2>
        <span className="text-gray-500 text-[16px]">Let's get you set up with a few quick questions</span>
      </div>
      <div className="mb-6">
        <div className="flex justify-between mb-4">
          <span className="text-gray-600">Step {step == -1 ? 3 : step} of 3</span>
          <span className="text-gray-600">{getCompletePercentage(step)} Complete</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-[#000c] h-2 rounded-full transition-all"
            style={{ width: `${(step / 3) * 100}%` }}
          />
        </div>
        <div className="flex justify-between mt-4">
          <span className={`${step >= 1 ? 'text-[#000c]' : 'text-gray-400'}`}>Company Info</span>
          <span className={`${step > 1 ? 'text-[#000c]' : 'text-gray-400'}`}>Your Role</span>
          <span className={`${step == 3 ? 'text-[#000c]' : 'text-gray-400'}`}>Objectives</span>
        </div>
      </div>

      {/* Form Content */}
      {step === 1 && (
        <div className="shadow-md rounded-xl border p-6 pb-[3rem]">
          <h2 className="text-xl font-semibold">Company Information</h2>
          <p className="text-gray-500 mb-6">
            Tell us about your company to help us tailor our services
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block  font-medium">Company Name *</label>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={(e) => handleChange('companyName', e.target.value)}
                className={`mt-1 w-full border rounded-lg px-3 py-2 outline-none bg-[#f3f3f5] border-[#a1a1a1] ${formErrors.companyName.showError ? 'border-red-500 focus:border-red-500 focus:shadow-[0_0_0_3px_#ef444426]' : 'focus:border-[#000c] focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)]'}`}
                placeholder="Enter your company name"
              />
              {formErrors.companyName.showError && <p className="text-red-500 text-sm mt-1">{formErrors.companyName.message}</p>}
            </div>

            <div>
              <label className="block  font-medium">Website URL</label>
              <input
                type="url"
                name="website"
                value={formData.website}
                onChange={(e) => handleChange('website', e.target.value)}
                className="mt-1 w-full border rounded-lg px-3 py-2 outline-none border-[#a1a1a1] bg-[#f3f3f5] focus:border-[#000c] focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)]"
                placeholder="https://your-website.com"
              />
            </div>

            <div>
              <label className="block  font-medium">Industry *</label>
              <Select
                options={industryOptions}
                value={industryOptions.find((option) => option.value === formData.industry)}
                onChange={(selected) => handleChange('industry', selected?.value || '')}
                placeholder="Select Industry"
                classNamePrefix={`commonSelect`}
                className={`selectInput ${formErrors.industry.showError ? 'commonSelectError' : ''}`}
                isClearable
              />
              {formErrors.industry.showError && <p className="text-red-500 text-sm mt-1">{formErrors.industry.message}</p>}
            </div>

            <div>
              <label className="block  font-medium">Country *</label>
              <Select
                options={countryOptions}
                value={countryOptions.find((option) => option.value == formData.country)}
                onChange={(selected) => handleChange('country', selected?.value || '')}
                placeholder="Select Country"
                classNamePrefix="commonSelect"
                className={`selectInput ${formErrors.country.showError ? 'commonSelectError' : ''}`}
                isClearable
              />
              {formErrors.country.showError && <p className="text-red-500 text-sm mt-1">{formErrors.country.message}</p>}
            </div>

            <div className="md:col-span-2">
              <label className="block font-medium">Company Size *</label>
              <Select
                options={companySizeOptions}
                value={companySizeOptions.find((option) => option.value == formData.size)}
                onChange={(selected) => handleChange('size', selected?.value || '')}
                placeholder="Select Company Size"
                classNamePrefix="commonSelect"
                className={`selectInput ${formErrors.size.showError ? 'commonSelectError' : ''}`}
                isClearable
              />
              {formErrors.size.showError && <p className="text-red-500 text-sm mt-1">{formErrors.size.message}</p>}
            </div>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="shadow-md rounded-xl border p-6 pb-[3rem]">
          <h2 className="text-xl font-semibold">Your Role</h2>
          <p className="text-gray-500 text-[15px] mt-1 mb-4">What best describes your role in the advertising ecosystem?</p>
          <div className="flex flex-col gap-5">
            <div className="flex items-center">
              <RadioButton className="commonRadio" inputId="ad_network" name="role" value="AdNetwork" onChange={(e) => handleChange('role', e.value)} checked={formData.role === 'AdNetwork'} />
              <label htmlFor="ad_network" className="ml-2 flex items-center gap-3 cursor-pointer"><span>Ad Network</span><span className="text-gray-500 font-medium">You connect advertisers with publishers</span></label>
            </div>
            <div className="flex items-center">
              <RadioButton className="commonRadio" inputId="agency" name="role" value="Agency" onChange={(e) => handleChange('role', e.value)} checked={formData.role === 'Agency'} />
              <label htmlFor="agency" className="ml-2 flex items-center gap-3 cursor-pointer"><span>Agency</span><span className="text-gray-500 font-medium">You manage campaigns on behalf of clients</span></label>
            </div>
            <div className="flex items-center">
              <RadioButton className="commonRadio" inputId="brand" name="role" value="Brand" onChange={(e) => handleChange('role', e.value)} checked={formData.role === 'Brand'} />
              <label htmlFor="brand" className="ml-2 flex items-center gap-3 cursor-pointer"><span>Brand</span><span className="text-gray-500 font-medium">You're advertising your own products/services</span></label>
            </div>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="shadow-md rounded-xl border p-6 pb-[3rem]">
          <h2 className="text-xl font-semibold">What do you want to achieve with us?</h2>
          <p className="text-gray-500 text-[15px] mt-1 mb-4">Select all that apply to help us understand your needs</p>
          <div className="flex flex-col gap-5">
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="campaigns" name="objectives" value="campaigns" onChange={(e) => handleObjective('objectives', e)} checked={formData.objectives?.includes('campaigns')} />
              <label htmlFor="campaigns" className="ml-2 flex items-center gap-3 cursor-pointer">Manage advertiser campaigns</label>
            </div>
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="publishers" name="objectives" value="publishers" onChange={(e) => handleObjective('objectives', e)} checked={formData?.objectives?.includes('publishers')} />
              <label htmlFor="publishers" className="ml-2 flex items-center gap-3 cursor-pointer">Find matching publishers / affiliates</label>
            </div>
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="validation" name="objectives" value="validation" onChange={(e) => handleObjective('objectives', e)} checked={formData.objectives?.includes('validation')} />
              <label htmlFor="validation" className="ml-2 flex items-center gap-3 cursor-pointer">Validation Management</label>
            </div>
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="invoices" name="objectives" value="invoices" onChange={(e) => handleObjective('objectives', e)} checked={formData.objectives?.includes('invoices')} />
              <label htmlFor="invoices" className="ml-2 flex items-center gap-3 cursor-pointer">Handle invoices & payouts</label>
            </div>
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="reports" name="objectives" value="reports" onChange={(e) => handleObjective('objectives', e)} checked={formData.objectives?.includes('reports')} />
              <label htmlFor="reports" className="ml-2 flex items-center gap-3 cursor-pointer">Reporting & dashboards</label>
            </div>
            <div className="flex items-center">
              <Checkbox className="commonCheckbox" inputId="other" name="objectives" value="other" onChange={(e) => handleObjective('objectives', e)} checked={formData.objectives?.includes('other')} />
              <label htmlFor="other" className="ml-2 flex items-center gap-3 cursor-pointer">Other (please specify)</label>
            </div>
          </div>
          {formData?.objectives?.some((item) => item === 'other') && (
            <div className="mt-5">
              <label htmlFor="otherObjText" className="block font-medium text-gray-700">Please specify:</label>
              <textarea
                id="otherObjText"
                placeholder="Tell us about your specific needs..."
                value={formData.otherObjText}
                onChange={(e) => handleChange('otherObjText', e.target.value)}
                onKeyDown={(e) => handleOtherObjective(e)}
                className="mt-1 w-full rounded-[8px] p-2 bg-[#f3f3f5] outline-none focus:shadow-[0_0_0_3px_rgba(0,0,0,0.1019607843)] focus:border-[#000c]"
              />
              <label className="text-gray-400 text-[12px] italic flex items-center gap-2"><i className="pi pi-info-circle"></i> Press enter to add a new objective</label>
            </div>
          )}
          {formData.objectives?.length > 0 && <div className="mt-5">
            <p>Selected objectives:</p>
            <div className="flex item-center gap-2 flex-wrap mt-2">
              {getAllObjectives()?.map((objective) => (
                <span className={`bg-gray-200 px-3 py-1 rounded-lg mr-2`}>{objective}</span>
              ))}
            </div>
          </div>}
        </div>
      )}

      {step == -1 &&
        <div className="flex items-center">
          <div className="bg-white shadow-md rounded-2xl h-[35vh] flex flex-col items-center justify-center p-8 text-center border border-gray-200 w-full">

            {/* Success Icon */}
            <div className="flex justify-center mb-4">
              <div className="bg-green-100 rounded-full p-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check-big w-8 h-8 text-green-600"><path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path></svg>
              </div>
            </div>

            {/* Heading */}
            <h2 className="text-2xl font-semibold text-gray-900 mb-2">
              Welcome aboard!
            </h2>

            {/* Description */}
            {/* <p className="text-gray-500 mb-6">
              Thank you for completing the onboarding process. Our team
              will review your information and get in touch with you shortly.
            </p> */}

            {/* Button */}
            <button
              className="px-6 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-100 transition w-fit"
              onClick={() => handleResetForm()}
            >
              Create Workspace
            </button>
          </div>
        </div>
      }

      {/* Navigation */}
      {step != -1 && <div className="mt-6 flex justify-between">
        <button
          disabled={step === 1}
          onClick={prevStep}
          className={`flex items-center gap-4 border px-4 py-2 hover:bg-gray-200 rounded-lg ${step === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <i className="pi pi-arrow-left text-[12px]" />
          Previous
        </button>

        <div className="flex items-center gap-4">
          {step < 3 ? (
            <button
              onClick={nextStep}
              className="px-4 py-2 bg-[#000c] text-white rounded-lg flex items-center gap-4"
            >
              Next
              <i className="pi pi-arrow-right text-[12px]" />
            </button>
          ) : (
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-[#000c] text-white rounded-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              disabled={isFormSubmitted}
            >
              {isFormSubmitted &&
                <div role="status">
                    <svg aria-hidden="true" class="inline w-8 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                    </svg>
                    <span class="sr-only">Loading...</span>
                </div>
              }
              Complete Onboarding
            </button>
          )}
        </div>
      </div>}
    </div>
  );
}